import InfographicCard from './InfographicCard';

export default InfographicCard;
